export const DEFAULT_TENANT_ID = 'trade-proof' as const;
export const DEFAULT_BRAND_ID = 'trade-proof' as const;

export const TENANT_IDS = [DEFAULT_TENANT_ID, 'warrior-trading'] as const;
export const BRAND_IDS = [DEFAULT_BRAND_ID, 'warrior-trading'] as const;
export const FEATURE_KEYS = ['googleAuth', 'advancedReplayStats', 'aiCoach', 'exportCsv', 'regularCustomerFeedback'] as const;

export type TenantId = (typeof TENANT_IDS)[number];
export type BrandId = (typeof BRAND_IDS)[number];
export type FeatureKey = (typeof FEATURE_KEYS)[number];

export type RuntimeFeatureFlags = Record<FeatureKey, boolean>;

export const DEFAULT_FEATURE_FLAGS: RuntimeFeatureFlags = {
  googleAuth: false,
  advancedReplayStats: false,
  aiCoach: false,
  exportCsv: false,
  regularCustomerFeedback: false,
};

export function createRuntimeFeatureFlags(flags?: Partial<RuntimeFeatureFlags>): RuntimeFeatureFlags {
  const nextFlags = { ...DEFAULT_FEATURE_FLAGS };

  for (const featureKey of FEATURE_KEYS) {
    nextFlags[featureKey] = flags?.[featureKey] === true;
  }

  return nextFlags;
}

export type BrandRuntimeConfig = {
  id: BrandId;
  displayName: string;
  frontDoor: 'marketing' | 'login';
  landingUrl: string;
  authUi: {
    portalLabel: string;
  };
};

export type TenantRuntimeConfig = {
  id: TenantId;
  brandId: BrandId;
  allowedHostnames: string[];
  features: RuntimeFeatureFlags;
};

export type ResolvedRuntimeConfig = {
  source: 'hostname' | 'env' | 'default';
  hostname: string;
  tenant: TenantRuntimeConfig;
  brand: BrandRuntimeConfig;
  features: RuntimeFeatureFlags;
};

export function normalizeTenantId(value?: string | null): TenantId | null {
  const normalized = String(value || '').trim().toLowerCase();

  if (!normalized) return null;
  if (normalized === 'default' || normalized === 'trade-proof') return 'trade-proof';
  if (normalized === 'warrior-trading') return 'warrior-trading';

  return null;
}

export function normalizeBrandId(value?: string | null): BrandId | null {
  const normalized = String(value || '').trim().toLowerCase();

  if (!normalized) return null;
  if (normalized === 'default' || normalized === 'trade-proof') return 'trade-proof';
  if (normalized === 'warrior-trading') return 'warrior-trading';

  return null;
}
